import React from 'react';
import {useIntl} from 'react-intl';
import {Button} from 'react-bootstrap';
import clsx from 'clsx';
import {ButtonSize} from '../../types/Forms';

interface ButtonCancelProps {
    onClick: () => void;
    textId: string;
    size?: ButtonSize;
}

const ButtonCancel: React.FC<ButtonCancelProps> = ({
    onClick,
    textId,
    size = 'medium',
}: ButtonCancelProps): JSX.Element => {
    const intl = useIntl();

    return (
        <Button
            type="button"
            variant="secondary"
            className={clsx({
                'btn-sm': size === 'small',
                'btm-lg': size === 'large',
            })}
            onClick={onClick}
        >
            {intl.formatMessage({id: textId})}
        </Button>
    );
};

export default ButtonCancel;
